import {getPermissions, getPagePermissions} from '../../api/endpoints/permissions'

export const state = {
  currentPage: 1,
  rows: 1,
  perPage: 1,
  data: [],
}

export const getters = {
  tableData: s => s.data,
  rows: s => s.rows,
  perPage: s => s.perPage,
  currentPage: s => s.currentPage
}

export const mutations = {
  GET_ROWS(state) {
    getPermissions().then( res => {
      state.rows = res.data.total
    })
  },
  GET_PER_PAGE(state) {
    getPermissions().then( res => {
      state.perPage = res.data.perPage
    })
  },
  GET_COUNT(state, id) {
    state.currentPage = id
    getPagePermissions(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_DATA(state) {
    getPagePermissions(state.currentPage).then( res => {
      state.data = res.data.data
    })
  }
}

export const actions = {
  getRows({commit}) {
    commit('GET_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAGE')
  },
  getCount({commit}, params) {
    commit('GET_COUNT', params)
  },
  getData({commit}) {
    commit('GET_DATA')
  }
}